//假设这里定义用户功能模块的api请求

//一般根据具体的接口服务模块约定
const baseURL = '/api'

export const smsApi = {
	//最简单的写法，列表啥也不用做
	//type['resetPwd', 'bandingMobile']
	sendSms(opt:any){
		var servicesPath = baseURL+'/v1/sms/code';		
		let context = opt.context;
		let pageData = opt.data||{};
		let urlParamObj = opt.urlParamObj||{};
		servicesPath+="?mobile="+opt.mobile+"&type="+opt.type;		
		context.$basicRequest.request({
			url: servicesPath,			
			context:context,
			waitingtip: '验证码发送中，请稍等...',
			ajaxOpt:{ //ajax的参数配置
				type: 'GET', //HTTP请求类型	
			},
			success(data:any, parameters:any){
				if (opt.success != undefined && typeof opt.success == "function") {
					opt.success(data,parameters);
				}
			}
		});
	},
	verifySms(opt:any){
		var servicesPath = baseURL+'/v1/sms/code';		
		let context = opt.context;
		let smsdata = opt.data||{};	
		context.$basicRequest.request({
			url: servicesPath,			
			context:context,
			waitingtip: '验证码校验中，请稍等...',
			ajaxOpt:{ //ajax的参数配置
				type: 'PUT', //HTTP请求类型	
			},
			data: smsdata,
			success(data:any, parameters:any){
				if (opt.success != undefined && typeof opt.success == "function") {
					opt.success(data,parameters);
				}
			}
		});
	}
}